/* eslint-disable no-mixed-operators */
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import styled from "styled-components";
import {
    AddButtonExtended,
    BackButton,
    ActionBar,
    TitleCardContainer,
    RadioButton,
    InputField,
    DrawerContainer,
    IconContainer,
    RadioFieldset,
    RadioContainerSide,

} from "../../globalStyles/CommonStyles";
import { useEffect, useState } from "react";
import { ReactComponent as BackIcon } from "../../assets/icons/back.svg";
import { ReactComponent as InfoIcon } from "../../assets/icons/info.svg";
import { RadioLegend } from '../../globalStyles/CommonStyles';
import { logEvent } from "firebase/analytics";
import { analytics } from "../../firebase.config";
import { getLastOrder, sendInterest } from "../../utils/functions";


const FormCheckout = styled.form`
  margin: 0 12px;
`;

const Title = styled.div`
    display: grid;
    margin-bottom: 16px;
    gap: 8px;

    h1{
        font-size: 2.4rem;
    }

    h2{
        font-size: 1.3rem;
        opacity: .6;
        font-weight: 400;
    }
`;

const Interested = () => {
    const history = useHistory();
    const lastOrder = getLastOrder();
    const { register, handleSubmit, formState: { errors }, } = useForm();
    const [sent, setSent] = useState(false);

    const onSubmit = (data: any) => {

        sendInterest(data).then(() => {
            try {
                setSent(true)
            } catch (e) {
                console.log(e);
            }
        }).catch(error => console.log(error));
    };

    useEffect(() => {
        logEvent(analytics, "interested")
    }, []);


    return (
        <DrawerContainer>
            <FormCheckout onSubmit={handleSubmit(onSubmit)}>
                {sent ? (
                    <Title>
                        <br />
                        <h1>¡Info enviada!</h1>
                        <h2>Gracias por comunicarte con nosotros</h2>
                    </Title>
                ) : (
                    <>
                        <TitleCardContainer>
                            <IconContainer>
                                <InfoIcon />
                            </IconContainer>
                            <h4>Menu interactivo y Pedidos online</h4>
                        </TitleCardContainer>
                        <div>
                            <Title>
                                <h1>Comentarios / Contactar</h1>
                                <h2>Si tienes un local gastronómico o emprendimiento y te interesa deja tus datos, sino dejanos tus comentarios.</h2>
                            </Title>
                            <RadioFieldset>
                                <RadioLegend>Motivo:</RadioLegend>
                                <RadioContainerSide>
                                    {/* {errors.type && <span>This is required</span>} */}
                                    <RadioButton noIcon="true">
                                        <input
                                            type="radio"
                                            id="contact"
                                            value="contact"
                                            defaultChecked
                                            {...register("motive", { required: true })}
                                        />
                                        <label htmlFor="contact">Contactar</label>
                                    </RadioButton>
                                    <RadioButton noIcon="true">
                                        <input
                                            type="radio"
                                            id="comment"
                                            value="comments"
                                            {...register("motive", { required: true })}
                                        />
                                        <label htmlFor="comment">Comentarios</label>
                                    </RadioButton>
                                </RadioContainerSide>
                            </RadioFieldset>
                            <InputField>
                                <label htmlFor="name">Nombre: {errors.name && <span> *es necesario*</span>}</label>
                                <input
                                    id="name"
                                    {...register("name", { required: true, minLength: 3 })}
                                    placeholder="Nombre"
                                    defaultValue={lastOrder?.info.name || ""}
                                />
                            </InputField>

                            <InputField>
                                <label htmlFor="phone">Celular: {errors.phone && <span> *es necesario*</span>}</label>
                                <input
                                    id="phone"
                                    className="bg phone"
                                    type="tel"
                                    {...register("phone", { required: true, minLength: 8 })}
                                    placeholder="Celular"
                                    defaultValue={lastOrder?.info.phone || ""}
                                />
                            </InputField>
                            <InputField>
                                <label htmlFor="name">Mensaje: (opcional)</label>
                                <input
                                    id="name"
                                    {...register("message", { required: false })}
                                    placeholder="Mensaje para el programador o ventas"
                                    defaultValue={""}
                                />
                            </InputField>
                        </div>
                    </>
                )

                }



                <ActionBar>
                    <BackButton type="button" onClick={() => history.goBack()}>
                        <BackIcon />
                        Volver
                    </BackButton>
                    {!sent && (
                        <AddButtonExtended type="submit">
                            <InfoIcon />
                            Enviar Info
                        </AddButtonExtended>
                    )}
                </ActionBar>

            </FormCheckout>
        </DrawerContainer>
    );
};

export default Interested;
